import type {
  Profile,
  UpdateProfileInput,
} from '../../domain/entities/profile.entity';
import type { ProfileApiDatasource } from '../datasources/profile-api.datasource';

export class ProfileRepositoryImpl {
  private readonly api: ProfileApiDatasource;

  constructor(api: ProfileApiDatasource) {
    this.api = api;
  }

  async getMe(): Promise<Profile> {
    return this.api.getMe();
  }

  async updateMe(data: UpdateProfileInput): Promise<void> {
    return this.api.updateMe(data);
  }
}
